import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  loadBatches (search) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/batches/?id=${search || ''}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  createBatch (batch) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/batches/', batch).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err.response.data)
      })
    })
  },

  checkSlug (slug) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/system/check-slug/batch/${slug}/`).then((res) => {
        if (res.data.status === 'exists') {
          resolve('exists')
        } else {
          resolve('available')
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },

  assignLot (batchId, lotId) {
    return new Promise((resolve, reject) => {
      axiosInstance.post(`/batches/${batchId}/add-lot/`, { id: lotId }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
